import React, { useEffect, useState } from 'react'; // { useEffect }
import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import * as actionTypes from '~/store/actions/actionTypes';
import { filterOptions } from '~/store/reducers/historyFilterOptions';
import {
  FormControl,
  MenuProps,
  MenuItem,
  ListItemText,
} from '../sharedStyles';

const CALL_TYPES = [{ name: 'All Calls' }, { name: 'My Calls' }];

export default function OwnershipSelector() {
  // HOOK's
  const dispatch = useDispatch();

  // SELECTOR's
  const selectedTypes = useSelector(
    (state: RootStateOrAny) => state.historyFilterOptions.types
  );
  const selectedTab = useSelector(
    (state: RootStateOrAny) => state.historyFilterOptions.selectedTab
  );

  // STATE's
  const [selected, setSelected] = useState<string[]>(['My Calls']);
  const [open, setOpen] = React.useState<boolean>(false);

  // EFFECT's
  useEffect(() => {
    setSelected(selectedTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedTypes?.length > 0) {
      setSelected(selectedTypes);
    }
  }, [selectedTypes]);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newSelectedTypes = event.target.value;

    dispatch({
      type: actionTypes.SET_HISTORY_FILTER_OPTIONS,
      option: filterOptions.types,
      payload: [newSelectedTypes],
      extra: { resetCallItems: true },
    });
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <div>
      <FormControl variant="outlined" hasselecteditems={selected?.length}>
        <Select
          id="select-ownership-types"
          labelId="select-ownership-types"
          disableUnderline
          input={<Input />}
          onOpen={handleToggle}
          onClose={handleToggle}
          onChange={handleChange}
          value={selected}
          renderValue={s => (s as string[]).join(', ')}
          // @ts-ignore
          MenuProps={MenuProps}>
          {CALL_TYPES.map(t => (
            <MenuItem key={t.name} value={t.name} width={200}>
              <ListItemText primary={t.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
